import { render, staticRenderFns } from "./ruleRight copy.vue?vue&type=template&id=13b1e986&scoped=true"
import script from "./ruleRight copy.vue?vue&type=script&lang=js"
export * from "./ruleRight copy.vue?vue&type=script&lang=js"
import style0 from "./ruleRight copy.vue?vue&type=style&index=0&id=13b1e986&prod&lang=scss&scoped=true"
import style1 from "./ruleRight copy.vue?vue&type=style&index=1&id=13b1e986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b1e986",
  null
  
)

export default component.exports